import _objectSpread from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
import AppHeader from '@/components/Header';
import AppFooter from '@/components/Footer';
import AppMain from '@/components/Main';
import ResizeMixin from "./mixin/ResizeHandler";
import UserAlert from '@/components/UserAlert';
import { mapActions, mapGetters } from 'vuex';
import { getOrgAssets } from '@data/setting';
export default {
  name: 'HeaderMain',
  mixins: [ResizeMixin],
  components: {
    AppHeader: AppHeader,
    AppMain: AppMain,
    AppFooter: AppFooter,
    UserAlert: UserAlert
  },
  data: function data() {
    return {
      mainHeight: 'auto',
      appMainHeight: 'auto',
      margin: null,
      minWidth: '1190px',
      background: '#f3f7fd',
      alertInfo: {},
      logoUrl: '',
      copyRight: ''
    };
  },
  computed: _objectSpread({}, mapGetters('user', {
    userAlert: 'userAlerts'
  })),
  mounted: function mounted() {
    this.getBgAndCopyRight();
    this.alertInfo = this.userAlert;
  },
  methods: _objectSpread({}, mapActions('user', {
    setUserAlert: 'setUserAlert'
  }), {
    clearFn: function clearFn() {
      this.setUserAlert(['flag', false]);
    },
    // 根据条件显示不同的背景图
    getBgAndCopyRight: function getBgAndCopyRight() {
      var _this = this;

      getOrgAssets({}).then(function (res) {
        _this.logoUrl = res.logoUrl;
        _this.copyRight = res.copyRight;
      }).catch(function (error) {
        console.log(error);
      });
    },
    resize: function resize() {
      // this.appMainHeight = (this.app.clientHeight - parseInt(footerHeight)) + 'px';
      this.appMainHeight = this.app.clientHeight + 'px';
      this.margin = '0 0';
      this.minWidth = '100%';
    }
  })
};